import { ChapterTag, MaskedLine, Reveal } from "@/components/bits";

const TILES = [
  { src: "/images/clubhouse.jpg", label: "The Apartment Clubhouse", ratio: "aspect-[16/10]" },
  { src: "/images/balcony.jpg", label: "Balcony View", ratio: "aspect-[4/5]" },
  { src: "/images/yoga.jpg", label: "Ribbon & Terrace Amenity Zone", ratio: "aspect-[4/3]" },
  { src: "/images/entrance.jpg", label: "Dedicated Entrance", ratio: "aspect-[4/3]" },
  { src: "/images/picnic.jpg", label: "Picnic Lawn", ratio: "aspect-[4/3]" },
];

const LIST = [
  "Swimming Pool", "Fitness Centre", "Meditation & Yoga Room",
  "Tennis · Pickleball · Padel", "Kids Zone", "Children's Park",
  "Riparian Corridor", "Pet Park", "Senior Citizen's Zone",
  "Apartment Clubhouse", "Celebration Lawn", "Dining & Banquet", "Picnic Lawn",
];

export default function Amenities() {
  return (
    <section id="amenities" className="bg-[#F5F4EF] py-24 md:py-36" data-testid="amenities-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <ChapterTag num="03" label="An Anchored Lifestyle" />
        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-end">
          <h2 className="font-display text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:col-span-7 lg:text-6xl">
            <MaskedLine inView delay={0.05}>Spaces to recharge,</MaskedLine>
            <MaskedLine inView delay={0.15}>
              connect, and <span className="italic text-[#064E3B]">truly belong.</span>
            </MaskedLine>
          </h2>
          <Reveal delay={0.3} className="lg:col-span-4 lg:col-start-9">
            <p className="max-w-sm text-sm leading-relaxed text-[#57534E] md:text-base">
              The Apartment Clubhouse is designed around a central anchor tree — porous,
              breathable architecture with light and greenery present throughout.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 columns-1 gap-5 sm:columns-2 md:mt-20 lg:columns-3" data-testid="amenities-gallery">
          {TILES.map((t, i) => (
            <Reveal key={t.label} delay={(i % 3) * 0.08} className="mb-5 break-inside-avoid">
              <figure className="group relative overflow-hidden rounded-sm">
                <img
                  src={t.src}
                  alt={t.label}
                  data-testid={`amenity-img-${i}`}
                  className={`${t.ratio} w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105`}
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#02120D]/75 to-transparent p-5 pt-12">
                  <span className="text-[10px] font-medium uppercase tracking-[0.26em] text-[#F5F1E8]">
                    {t.label}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-14">
          <div className="flex flex-wrap gap-x-8 gap-y-3 border-t border-[#1C1917]/15 pt-8" data-testid="amenities-list">
            {LIST.map((a) => (
              <span key={a} className="font-display text-lg italic text-[#1C1917]/75 md:text-xl">
                {a}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
